import { bunja } from 'bunja';
import { atom } from 'jotai';

import { accountAtom } from './internal/fixed-topics/account';
import { r230522SocketBunja } from './socket';

export type * from './internal/fixed-topics/account';

const v2AccountAtom = atom((get) => {
  const account = get(accountAtom);
  if (!account) return null;

  // accountId key 걷어내서 사용하기 위해
  return Object.values(account)[0];
});
v2AccountAtom.debugLabel = 'v2AccountAtom';

export const accountBunja = bunja(() => {
  bunja.use(r230522SocketBunja);
  return { accountAtom, v2AccountAtom };
});
